// social-buttons-gamer.js
document.addEventListener('DOMContentLoaded', function() {
    // Toggle para mostrar/ocultar botones en móvil
    const toggleBtn = document.getElementById('toggleSocialGamer');
    const socialButtons = document.getElementById('socialButtonsGamer');
    
    if (toggleBtn && socialButtons) {
        toggleBtn.addEventListener('click', function() {
            socialButtons.classList.toggle('active');
        });
    }

    // Efecto hover adicional en desktop
    const socialBtns = document.querySelectorAll('.social-btn-gamer');
    socialBtns.forEach(btn => {
        btn.addEventListener('mouseenter', function() {
            this.style.transform = 'scale(1.15) rotate(5deg)';
        });
        
        btn.addEventListener('mouseleave', function() {
            this.style.transform = 'scale(1)';
        });
    });
});